import styles from "./css/AlternativeElectricity.module.css";
import { GraphsCard } from "@/components/cards/GraphsCard";
import { ElectricityContent } from "./ElectricityContent";
import { AlternativeData } from "@/types/alternative";
import { ModelView } from "@/components/files/ModelView";
import { GIS } from "@/GIS/GIS";
import { CityData } from "@/types/city";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { Project } from "@/types";
interface AlternativeElectrictyProps {
    alternative: AlternativeData;
    city: CityData | null;
    project: Project; 
}

export const AlternativeElectricty = ({ alternative, city, project }: AlternativeElectrictyProps) => {
    const ao = useSelector((state: RootState) => state.entity.userAo);
    return (
        <div className={styles.container}>
            <ElectricityContent alternative={alternative} project={project} />
            <div className={styles.mapContent}>
                {city && <GIS city={city} projectId={alternative.project_id} office={ao || undefined} onFeatureClick={() => {alert("clicked")}}></GIS>}
            </div>
        </div>
    );
}